import React, {useEffect} from 'react';
import axios from 'axios';

export type StudioMode = 'LITE' | 'FULL';

export type StudioModeContextType = {
  mode: StudioMode;
  name: string; // TODO: do some cleanup (STUDCL-17957)
  setMode: React.Dispatch<React.SetStateAction<StudioMode | undefined>>;
};

const StudioModeContext = React.createContext<StudioModeContextType | undefined>(
  undefined
);

type StudioFeaturePack = {
  name: string;
};

export const StudioModeProvider = ({children}: {children: React.ReactNode}) => {
  const [mode, setMode] = React.useState<StudioMode>();
  const [name, setName] = React.useState<string>('');

  useEffect(() => {
    const fetchMode = async () => {
      var mode: StudioMode = 'FULL';
      try {
        const {data} = await axios.get<{body: Array<StudioFeaturePack>}>(
          '/studio/feature/packs'
        );
        if (data.body.length === 1) {
          if (data.body[0].name === 'core') {
            mode = 'LITE';
            setName('core');
          } else if (data.body[0].name === 'lite') {
            mode = 'LITE';
            setName('lite');
          }
        }
      } catch (e) {
        console.error(e);
      }
      setMode(mode);
    };
    fetchMode();
  }, []);

  return mode ? (
    <StudioModeContext.Provider value={{mode, name, setMode}}>
      {children}
    </StudioModeContext.Provider>
  ) : null;
};

export const useStudioMode = () => {
  const context = React.useContext(StudioModeContext);
  if (!context) {
    throw new Error('useStudioModeProvider must be used within a StudioModeProvider');
  }
  return context;
};

// For use in class components
export const StudioModeConsumer = ({
  children,
}: {
  children: (context: StudioModeContextType) => React.ReactNode;
}) => {
  return (
    <StudioModeContext.Consumer>
      {context => {
        if (!context) {
          throw new Error(
            'useStudioModeProvider must be used within a StudioModeProvider'
          );
        }
        return children(context);
      }}
    </StudioModeContext.Consumer>
  );
};
